"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleDate = void 0;
var jsx_runtime_1 = require("preact/jsx-runtime");
var _1 = require(".");
var SimpleDate = function (_a) {
    var date = _a.date, dateConfig = _a.dateConfig;
    var parsedDate = date ? (0, _1.parseStringDate)(date) : null;
    var finalDate = parsedDate
        ? "".concat(dateConfig.weekdays[parsedDate.weekday], ", ").concat(dateConfig.months[parsedDate.month], " ").concat(parsedDate.day)
        : '';
    return ((0, jsx_runtime_1.jsx)("div", { class: "artajs__tracking__timeline__status__date", children: (0, jsx_runtime_1.jsx)("div", { class: "artajs__tracking__timeline__status__date__content", children: finalDate }) }));
};
exports.SimpleDate = SimpleDate;
